export const MAX_VISIBLE_THUMBNAILS = 4;

export const THUMBNAIL_URL_SIZE = {
    width: 48,
    height: 60,
};

export const MOBILE_THUMBNAIL_ELEMENT_SIZE = {
    width: 48,
    height: 60,
};

export const DESKTOP_THUMBNAIL_ELEMENT_SIZE = {
    width: 64,
    height: 80,
};

export const THUMBNAIL_STRIP_GAP = 12;
